import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import Header from "components/common/Header/Header";
import withAuth from "hocs/withAuth";
import withPermission from "hocs/withPermission";
import useToken from "hooks/useToken";
import { Link } from "react-router-dom";
import { IOGBooking } from "interfaces/ogBooking";
import OGBookingServices from "services/ogBooking";

const Dashboard = () => {
  const { token } = useToken();
  const [booking, setBooking] = useState<IOGBooking[]>([]);
  const [loading, sertLoading] = useState<boolean>(true);

  useEffect(() => {
    OGBookingServices.getAllBooking(token as string)
      .then((res) => {
        setBooking(res.data.data);
        sertLoading(false);
      })
      .catch((err) => {
        sertLoading(false);
      });
  }, []);

  return (
    <>
      <Header
        title="Dashboard"
        breadcrumbs={[
          {
            label: "Dashboard",
            href: "/dashboard",
          },
          {
            label: "Only Golf",
            href: "/dashboard/only-golf",
          },
          {
            label: "Club Fitting",
          },
        ]}
      />
      {loading ? (
        <div>Loading...</div>
      ) : (
        <div>
          <FullCalendar
            plugins={[dayGridPlugin]}
            initialView="dayGridMonth"
            events={booking.map((b, index) => {
              let data = [
                index.toString().padStart(20, "0"),
                b.id,
                b.first_name + " " + b.last_name,
                `${b.booking_start_time.substring(
                  0,
                  5
                )} น. - ${b.booking_end_time.substring(0, 5)} น.`
              ];
              return {
                title: data.join("|"),
                date: b.booking_date,
              };
            })}
            eventContent={EventDetail}
          />
        </div>
      )}
    </>
  );
};

const EventDetail = ({ event }: { event: { title: string } }) => {
  let data = event.title.split("|");
  let id = data[1];
  let user = data[2];
  let time = data[3];
  const content = (
    <Link to={`/booking/only-golf/${id}`}>
      <Box
        sx={{
          p: 1,
          backgroundColor: "#109747",
        }}
      >
        <Typography>
          <Typography fontWeight={700} display={"inline"} fontSize={12}>
            Name:
          </Typography>
          <Typography fontSize={12}>{user}</Typography>
        </Typography>
        <Typography>
          <Typography fontWeight={700} display={"inline"} fontSize={12}>
            Time:
          </Typography>
          <Typography fontSize={12}>{time}</Typography>
        </Typography>
      </Box>
    </Link>
  );
  return content;
};

export default withAuth(withPermission(Dashboard, "MANAGE_ONLY_GOLF"));
